import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import { type AgentOnboardingTimeSinkId } from './agentOnboardingAnalytics';
import META from './useTrackAgentOnboardingInterestSelected.meta';
import { withWorkspaceAgentCategory } from './workspaceAgentAnalytics';

export type { AgentOnboardingTimeSinkId } from './agentOnboardingAnalytics';

export type UseTrackAgentOnboardingInterestSelectedParams = {
  interest: AgentOnboardingTimeSinkId;
  selected: boolean;
};

export const useTrackAgentOnboardingInterestSelected = () => {
  const { track } = useAnalyticsUtilities();

  const trackAgentOnboardingInterestSelected = useCallback(
    (params: UseTrackAgentOnboardingInterestSelectedParams) => {
      track(META.name, withWorkspaceAgentCategory(params));
    },
    [track],
  );

  return { trackAgentOnboardingInterestSelected };
};
